import { Badge, BadgeProps, Inline, InlineProps } from "@sembark-travel/ui-base"
import { ITag } from "./store"
import { utcTimestampToLocalDateString } from "@sembark-travel/datetime-utils"

type TagBadgeProps = BadgeProps & {
	tag: ITag
}

export function TagBadge({ tag, ...badgeProps }: TagBadgeProps) {
	return (
		<Badge
			{...badgeProps}
			style={{
				backgroundColor: tag?.style?.background_color,
				color: tag?.style?.text_color,
				...badgeProps.style,
			}}
			title={
				tag?.pivot?.created_at
					? utcTimestampToLocalDateString(tag.pivot.created_at)
					: undefined
			}
		>
			{tag.name}
		</Badge>
	)
}

type TagBadgesProps = InlineProps & {
	tags: ITag[] | undefined
}

export function TagBadges({ tags, gap = "1", ...props }: TagBadgesProps) {
	if (!tags?.length) {
		return null
	}
	return (
		<Inline gap={gap} flexWrap="wrap" {...props}>
			{tags.map((tag) => (
				<TagBadge key={tag.id} tag={tag} />
			))}
		</Inline>
	)
}
